import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";


import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";

//import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
//import StatusBadge from "../dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, LineTrendChart, RadarChart } from "../../components/charts";

const kpiByAxis = [
  { label: "Axe 1 · Logistique", value: 74, color: "#116B43" },
  { label: "Axe 2 · Croissance", value: 52, color: "#D68910" },
  { label: "Axe 3 · Exécution", value: 63, color: "#2471A3" },
  { label: "Axe 4 · Gouvernance", value: 68, color: "#163A5F" },
];

const kpiTrend = [55, 58, 60, 62, 65, 67, 69, 70, 71, 72, 73, 74];

const underperforming = [
  {
    title: "Croissance volume gaz",
    description: "La progression reste inférieure à l’objectif fixé pour le S1.",
    tone: "warning" as const,
  },
  {
    title: "Disponibilité systèmes critiques",
    description: "Instabilité observée sur certaines plateformes SI.",
    tone: "danger" as const,
  },
];

const kpiBudgetCorrelation = [
  { label: "Logistique vs Budget", value: 71, color: "#116B43" },
  { label: "Gouvernance vs Budget", value: 64, color: "#163A5F" },
  { label: "Croissance vs Budget", value: 48, color: "#D68910" },
];

export default class PerformanceDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {kpiTrend={},kpiTraffic={},objectivePerformance={},activityContribution={}} = sections;

  // const  = sections.kpiTrend || {}
  // const  = sections.kpiTraffic || {}
  // const  = sections.objectivePerformance || {}
  // const activityContribution = sections.activityContribution || {}

// 'icon', 'projects',
// 'icon', 'track',
// 'icon', 'investment',
// 'icon', 'equalizer',
// 'icon', 'warning',
  
  const iconMap: any = {
    track: <TrackChangesOutlinedIcon />,
    success: <CheckCircleOutlineOutlinedIcon />,
    danger: <ErrorOutlineOutlinedIcon />,
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard KPI & Performance"
        subtitle="Suivi de la performance stratégique, des axes, des KPI et de leur cohérence avec les activités et le budget."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 2 }}>
        {summaryCards.map((card: any) => (
          <SummaryCard
            key={card.code}
            title={card.label}
            value={card.valueFormatted}
            subtitle={card.subtitle}
            delta={card.deltaFormatted}
            tone={card.tone}
            icon={iconMap[card.icon] || <TrackChangesOutlinedIcon />}
          />
        ))}
      </Box>

      <Box sx={{display:"grid", gap:2, gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" }}} >
        <SectionCard
          title={kpiTrend.title || "Tendance KPI"}
          subtitle="Evolution du score global."
        >
          <LineTrendChart data={kpiTrend.data || []} />
        </SectionCard>

        <SectionCard
          title={kpiTraffic.title || "KPI critiques"}
          subtitle="KPI nécessitant attention."
        >
          <DonutChart data={kpiTraffic.data || []} />
        </SectionCard>
      </Box>

      <Box sx={{display:"grid", gap:2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" }}} >
        <SectionCard
          title={objectivePerformance.title || "Performance par objectif"}
        >
          <RadarChart data={(objectivePerformance.data || [])}
          />
        </SectionCard>

        <SectionCard
          title={activityContribution.title || "Contribution activités"}
        >
          <TreemapChart 
            data={(activityContribution.data || [])}
          />
        </SectionCard>
      </Box>
      

      {/* <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Score global"
          value="71%"
          subtitle="Performance consolidée"
          delta="+2 pts"
          tone="success"
          icon={<TrackChangesOutlinedIcon />}
        />
        <SummaryCard
          title="KPI atteints"
          value="18 / 26"
          subtitle="Objectifs atteints"
          delta="69%"
          tone="info"
          icon={<TrendingUpOutlinedIcon />}
        />
        <SummaryCard
          title="KPI en retard"
          value="6"
          subtitle="Sous cible"
          delta="À surveiller"
          tone="warning"
          icon={<TrendingDownOutlinedIcon />}
        />
        <SummaryCard
          title="Axes couverts"
          value="4"
          subtitle="Axes stratégiques"
          delta="100%"
          tone="default"
          icon={<HubOutlinedIcon />}
        />
        <SummaryCard
          title="Alertes KPI"
          value="2"
          subtitle="Critiques"
          delta="Priorité haute"
          tone="danger"
          icon={<WarningAmberOutlinedIcon />}
        />
        <SummaryCard
          title="Tendance"
          value="+"
          subtitle="Amélioration continue"
          delta="Stable"
          tone="success"
          icon={<InsightsOutlinedIcon />}
        />
      </Box> */}

      {/* <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard title="Tendance KPI">
            <MockTrendChart points={kpiTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard title="KPI sous-performance">
            <AlertList items={underperforming} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard title="Performance par axe">
            <MockBarChart data={kpiByAxis} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard title="Corrélation Budget / KPI">
            <MockBarChart data={kpiBudgetCorrelation} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard title="Lecture stratégique">
            <Stack spacing={1.25}>
              {[
                ["Performance globale satisfaisante", "Les KPI stratégiques montrent une progression stable."],
                ["Axes à renforcer", "Certains axes nécessitent des efforts ciblés."],
                ["Alignement en amélioration", "Lien entre budget, activité et KPI mieux maîtrisé."],
              ].map(([title, desc]) => (
                <Box key={title} sx={{ p: 1.5, border: "1px solid #E2E8EE", borderRadius: "10px" }}>
                  <Typography sx={{ fontWeight: 800 }}>{title}</Typography>
                  <Typography sx={{ fontSize: 13 }}>{desc}</Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}